export { default } from './CommentsDialog';
